export default {"src":"/_next/static/media/Frame 427319761.8c20dad7.svg","height":453,"width":556,"blurWidth":0,"blurHeight":0};